module.exports = __webpack_public_path__ + "static/img/16.b8b4826.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/gameNewPic/16.jpg
// module id = roqJ
// module chunks = 1